import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

import {OPTION_TYPES} from './constants';
import {StepChecksOptionWrapper, OptionCheck, OptionUncheck, StyledCheckIcon, StyledUncheckIcon} from './styles';

const {CHECKMARK, CLOSE} = OPTION_TYPES;

@inject('store')
@observer
class Options extends Component {
  onOptionPress = option => {
    const {
      stepId,
      store: {
        checklist: {updateChecklist}
      }
    } = this.props;

    const checked = option === CHECKMARK;
    const unchecked = option === CLOSE;

    updateChecklist(stepId, {checked, unchecked});
  };

  render() {
    const {
      store: {
        checklist: {checklist}
      },
      stepId,
      stepIndex
    } = this.props;

    const status = checklist[stepId] || {};

    const {checked, unchecked} = status;

    return (
      <StepChecksOptionWrapper>
        <OptionCheck
          data-cy={`option-${stepIndex}-checked`}
          onClick={() => this.onOptionPress(CHECKMARK)}
          checked={checked}
        >
          <StyledCheckIcon checked={checked} />
        </OptionCheck>
        <OptionUncheck
          data-cy={`option-${stepIndex}-unchecked`}
          onClick={() => this.onOptionPress(CLOSE)}
          unChecked={unchecked}
        >
          <StyledUncheckIcon unChecked={unchecked} />
        </OptionUncheck>
      </StepChecksOptionWrapper>
    );
  }
}

export default Options;
